<template>
  <div class="layout">
    <aside class="menu">
      <div class="menu-action" @click="goToHome">
        <img src="@/assets/icons/ws-icon.svg" class="menu-icon" />
      </div>
      <div class="menu-content">
        <menu-item v-for="(item, index) in allowedLinks" :key="index"
          :to="item.to" :params="item.params" :iconName="item.iconName" :title="item.title"
          :extraAction="item.extraAction"/>
      </div>
    </aside>
    <div class="content">
     <router-view/>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { PermissionsList } from '@/helpers/permissions.js';

import MenuItem from '@/components/MenuItem.vue';

export default {
  name: 'Base',
  components: {
    MenuItem,
  },
  computed: {
    ...mapState('misc', ['siteSettings']),
    ...mapState('session', ['permissions']),
    ...mapGetters('session', ['isAuthenticated']),
    links() {
      return [{
          title: 'Мои проекты и КТ',
          to: `dashboard_${this.siteSettings.defaultDashboardView}`,
          iconName: 'home',
          params: {},
        }, {
          title: 'Мероприятия',
          to: 'events',
          iconName: 'calendar-check',
          params: {
            page: 1,
          },
          requiredPermissions: [
            PermissionsList.EventView,
            PermissionsList.EventViewAll,
          ],
        }, {
          title: 'Настройки',
          to: 'settings',
          iconName: 'cog',
          params: {},
          requiredPermissions: [
            PermissionsList.FndView,
            PermissionsList.UserView,
            PermissionsList.RoleView,
            PermissionsList.SkillView,
            PermissionsList.SponsorView,
            PermissionsList.EventRoleCreate,
            PermissionsList.EventRoleUpdate,
            PermissionsList.EventRoleDelete,
            PermissionsList.FndOrganizationView,
            PermissionsList.ControlPointRequestViewAll,
            PermissionsList.ControlPointRequestView
          ],
        }, {
          title: 'Пользователи',
          to: 'users',
          iconName: 'user',
          params: {
            page: 1,
          },
          requiredPermissions: [
            PermissionsList.UserView,
          ],
        }, {
          title: 'Выход',
          to: 'logout',
          iconName: 'sign-out-alt',
          params: {},
          extraAction: () => {
            this.$toasted.info("Выйти?", { action: [{
              text: "Да",
              push: {
                name: 'logout',
              },
            }, {
              text: "Нет",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            }]});
          },
        },
      ];
    },
    allowedLinks() {
      return this.isAuthenticated ? this.links.filter(link => this.isAccessAllowed(link.requiredPermissions)) : [];
    },
  },
  methods: {
    isAccessAllowed(requiredPermissions) {;
      let result = false;
      if (!requiredPermissions) {
        result = true;
        return result;
      } else {
        requiredPermissions.forEach(slug => {
          result = result || this.permissions[slug];
        });
        return result;
      }
    },
    goToHome() {
      this.$router.push({ name: 'index' });
    }
  },
};
</script>

<style lang="scss" scoped>

.layout {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 60px auto;

  .menu {
    z-index: 99;
    position: fixed;
    width: 60px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    grid-row-start: 1;
    grid-row-end: span 2;
    grid-column-start: 1;
    background: $surface;

    &-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
    }

    &-action {
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        cursor: pointer;
      }

    }

  }

  .content {
    grid-row-start: 1;
    grid-row-end: span 2;
    grid-column-start: 2;
  }

}
</style>
